import { colorConstants } from 'config/colorConstants';

//Figma: Global Filter V2 header > Icon End > chevron-right-double
const ChevronDoubleRight = ({
    fill = colorConstants.filterV2TextSecondary,
    direction = 'right',
    size = 16,
}: {
    fill?: string;
    direction?: 'right' | 'left';
    size?: number;
}) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.52864 4.19531C3.78899 3.93496 4.211 3.93496 4.47134 4.19531L7.80468 7.52865C8.06503 7.78899 8.06503 8.211 7.80468 8.47135L4.47134 11.8047C4.211 12.065 3.78899 12.065 3.52864 11.8047C3.26829 11.5443 3.26829 11.1223 3.52864 10.862L6.39062 8L3.52864 5.13802C3.26829 4.87767 3.26829 4.45566 3.52864 4.19531ZM8.1953 4.19531C8.45565 3.93496 8.87766 3.93496 9.13801 4.19531L12.4713 7.52865C12.7317 7.78899 12.7317 8.211 12.4713 8.47135L9.13801 11.8047C8.87766 12.065 8.45565 12.065 8.1953 11.8047C7.93495 11.5443 7.93495 11.1223 8.1953 10.862L11.0573 8L8.1953 5.13802C7.93495 4.87767 7.93495 4.45566 8.1953 4.19531Z"
            fill={fill}
            transform={direction === 'left' ? 'rotate(180 8 8)' : undefined}
        />
    </svg>
);

export default ChevronDoubleRight;
